import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import home from "@/views/home/index.vue"
import assetsuit from "@/views/assetsuit/index.vue"
import homepre from "@/views/homepre/index.vue"
import store from "@/views/store/index.vue"
import store_list from "@/views/store_list/index.vue"
import create from "@/views/create/index.vue"
import wallet from "@/views/wallet/index.vue"
import activity from "@/views/activity/index.vue"
import profile from "@/views/profile/index.vue"
import gallery from "@/views/gallery/index.vue"
import detail from "@/views/detail/index.vue"

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    component: home
  },
  {
    path: "/assetsuit/:address",
    name: "assetsuit",
    component: assetsuit
  },
  {
    path: "/homepre",
    name: "homepre",
    component: homepre
  },
  {
    path: "/stores",
    name: "store",
    component: store
  },
  {
    path: "/store_list",
    name: "store_list",
    component: store_list
  },
  {
    path: "/create",
    name: "create",
    component: create
  },
  {
    path: "/wallet",
    name: "wallet",
    component: wallet
  },
  {
    path: "/activity",
    name: "activity",
    component: activity
  },
  {
    path: "/profile",
    name: "profile",
    component: profile
  },
  {
    path: "/my_collection",
    name: "gallery",
    component: gallery
  },
  {
    path: "/detail/:id",
    name: "detail",
    component: detail
  },
  {
    path: "/assets/:address/:id",
    name: "asset",
    component: detail
  },
];

const router = new VueRouter({
  // mode: 'hash',
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
});

export default router;
